<div class="dialogContainer" [ngClass]="{ 'visible': showCreateModal }">
  <div class="dialog">
    <div class="cell large-12 medium-12 small-12 bold">
      Create System Alert
    </div>
    @if (showCreateModal && alertForm) {
      <div class="cell large-12 medium-12 small-12">
        <form [formGroup]="alertForm" (ngSubmit)="createAlert()">
          <label for="alertTitle" class="bold">Title:</label>
          <input id="alertTitle" type="text" formControlName="title" class="input-field" />
          @if (alertForm.get('title').invalid && alertForm.get('title').touched) {
            <div class="error">
              Title is required.
            </div>
          }
          <label for="alertMessage" class="bold">Message:</label>
          <textarea id="alertMessage" formControlName="message" class="input-field" rows="4"></textarea>
          @if (alertForm.get('message').invalid && alertForm.get('message').touched) {
            <div class="error">
              Message is required.
            </div>
          }
          <label for="startDate" class="bold">Start Date:</label>
          <input id="startDate" type="datetime-local" formControlName="startDate" class="input-field" />
          @if (alertForm.get('startDate').invalid && alertForm.get('startDate').touched) {
            <div class="error">
              Start Date is required.
            </div>
          }
          <label for="endDate" class="bold">End Date:</label>
          <input id="endDate" type="datetime-local" formControlName="endDate" class="input-field" />
          @if (alertForm.get('endDate').invalid && alertForm.get('endDate').touched) {
            <div class="error">
              End Date is required.
            </div>
          }
          <!-- Error message for invalid date range -->
          @if (alertForm.errors?.dateRangeInvalid) {
            <div class="error">
              Start Date cannot be greater than End Date.
            </div>
          }
        </form>
      </div>
    }
    <div class="dialogButtonsContainer">
      <div class="text-align-center">
        <button class="button margin-left no-margin-bottom outline-offset-1" [disabled]="savingAlert" (click)="cancel()">Cancel</button>
        <button class="button margin-left no-margin-bottom outline-offset-1" [disabled]="alertForm.invalid || savingAlert" (click)="createAlert()">Save</button>
      </div>
    </div>
    <text-loader [run]="savingAlert" [tickType]="'.'" [text]="'Saving Alert'" [interval]="1500"></text-loader>
  </div>
</div>